export default "__VITE_ASSET__CPAwAItQ__"